import AbstractAction from "../AbstractAction";

export default class ToggleLayerVisibilityAction extends AbstractAction {
    constructor(provider, layer) {
        super(provider);

        this.layer = layer;
    }

    finish() {
        this.layer.visible = !this.layer.visible;
        super.finish();
    }

    undo() {
        this.layer.visible = !this.layer.visible;
    }

    redo() {
        this.layer.visible = !this.layer.visible;
    }
}
